import { isReadWaiveAsked } from '@/components/Event/NewScript/utils/errata'
import { ErrataPolicy, EventFeedback, SaScriptFields } from '@/types'

// Event-level defaults seeded into the form so every `sa.*` path exists for getInputProps.
export const DEFAULT_SA_FIELDS: SaScriptFields = {
  cr_joined: null,
  announce_record: null,
  record_preferences: '',
}

// Per-witness CR Form defaults, merged into each events_feedbacks entry so the new
// field paths exist for getInputProps. Types are pulled from EventFeedback to stay in
// sync with the submit payload shape.
export const DEFAULT_WITNESS_CR_FIELDS: Required<
  Pick<
    EventFeedback,
    | 'spellings'
    | 'read_waive'
    | 'orders_present'
    | 'on_record'
    | 'attendee_orders'
  >
> = {
  spellings: '',
  read_waive: null,
  orders_present: null,
  on_record: false,
  attendee_orders: {},
}

export const READ_WAIVE_OPTIONS = [
  { value: 'read', label: 'Read' },
  { value: 'waive', label: 'Waive' },
  { value: 'na', label: 'N/A' },
]

export type CrReadWaive = NonNullable<EventFeedback['read_waive']>

export const crReadWaiveToRecord = (
  errataPolicy: ErrataPolicy | null | undefined,
  current: CrReadWaive | null,
): CrReadWaive | null => (isReadWaiveAsked(errataPolicy) ? current : 'na')
